import { getParentOfType, Instance, types } from 'mobx-state-tree';
import { v1 as uuid } from 'uuid';

const Notification = types
    .model('Notification', {
        id: types.optional(types.identifier, () => uuid()),
        show: types.boolean,
    })
    .volatile(self => ({
        component: {} as React.ComponentType<any>,
    }))
    .views(self => ({
        get parent(): INotifications {
            return getParentOfType(self, Notifications);
        },
    }))
    .actions(self => ({
        hide: () => {
            self.show = false;
        },
        remove: () => {
            self.parent.remove(self.id);
        },
        setComponent: (com: React.ComponentType) => {
            self.component = com;
        },
    }));

export interface INotification extends Instance<typeof Notification> {}
export interface INotifications extends Instance<typeof Notifications> {}

const Notifications = types
    .model('NotificationStore', {
        list: types.array(Notification),
    })
    .views(self => ({
        get shows() {
            return self.list.filter(one => one.show);
        },
    }))
    .actions(self => ({
        remove: (id: string) => {
            const index = self.list.findIndex(x => x.id === id);
            if (index >= 0) self.list.splice(index, 1);
        },
        add: (component: React.ComponentType, { show = true }: { show?: boolean } = {}) => {
            const one = Notification.create({ show });
            one.setComponent(component);
            self.list.push(one);
            return one;
        },
        toggle: () => {
            let show = true;
            self.list.forEach(one => {
                show = show && one.show;
            });
            self.list.forEach(one => {
                one.show = !show;
            });
        },
    }));

export default Notifications;
